import { render, staticRenderFns } from "./EnvironmentalControlChart.vue?vue&type=template&id=fbd0155c&"
import script from "./EnvironmentalControlChart.vue?vue&type=script&lang=ts&"
export * from "./EnvironmentalControlChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbd0155c')) {
      api.createRecord('fbd0155c', component.options)
    } else {
      api.reload('fbd0155c', component.options)
    }
    module.hot.accept("./EnvironmentalControlChart.vue?vue&type=template&id=fbd0155c&", function () {
      api.rerender('fbd0155c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/reports/dashboard/components/EnvironmentalControlChart.vue"
export default component.exports